/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks if 'value' is true (strict equality).
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if the 'value' is true, else false.
 * @example
 *
 * isTrue(true);
 * // -> true
 *
 * isTrue(false);
 * // -> false
 *
 * isTrue();
 * // -> false
 */
export const isTrue = (value) => {
  return value === true;
};
